import type {
  GetSettings200AimIntegrationsItem,
  PatchSettingsBodyAimIntegrationsItem,
} from '@ipfabric/api-client/client/schemas';
import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import { z } from 'zod';
import { AimIntegrationsTable } from '../components/ApplicationMapping/tables/AimIntegrationsTable';
import type { DiscoverySettingsObject } from '../model/DiscoverySettingsObject';
import type { AimIntegrationDraft } from '../model/aimDrafts';

type AimIntegrationsFieldValues = {
  aimIntegrations: AimIntegrationDraft[];
};

export const storedAimIntegrations: FormSnippet<
  DiscoverySettingsObject,
  AimIntegrationsFieldValues
> = {
  render: ({ form }) => <AimIntegrationsTable form={form} />,

  fromModel: (model, draft) => {
    draft.aimIntegrations = (model.aim?.integrations ?? []).map((item) => ({
      id: item.id,
      platform: 'Illumio',
      apiUrl: item.apiUrl,
      apiKey: item.apiKey,
      apiSecret: item.apiSecret,
      organizationId: item.organizationId,
      slug: item.slug,
      comment: item.comment,
    }));
  },

  toModel: (values, modelDraft) => {
    modelDraft.aim ??= {
      integrations: [],
      manual: { applications: [], workloads: [], flows: [] },
    };
    modelDraft.aim.integrations = values.aimIntegrations.map(
      (item): PatchSettingsBodyAimIntegrationsItem => ({
        id: item.id,
        platform: 'Illumio',
        apiUrl: item.apiUrl,
        apiKey: item.apiKey,
        apiSecret: item.apiSecret,
        organizationId: item.organizationId,
        slug: item.slug,
        comment: item.comment,
      }),
    ) as GetSettings200AimIntegrationsItem[];
  },

  schema: z.object({
    aimIntegrations: z.array(z.unknown()),
  }) as z.Schema<AimIntegrationsFieldValues>,
};
